import React from 'react';
import img from '../assets/home.svg';
import styles from './icon-home.module.scss';

const IconHome = () => (
  <div className={styles.iconHome} style={{backgroundImage: `url(${img})`}} />
);

export default IconHome;
